import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { Redirect } from 'react-router-dom';
import { GetUserDetails, SuperAdmin, ClearUsers } from '../../store/actions/userActions'; 
import { Spin, Table, Switch, Layout, Col } from 'antd';
import TextField from '@material-ui/core/TextField';
import _ from "lodash";
import 'antd/dist/antd.css';

const { Content } = Layout;

function UserDetails(props) {
    const [isLoading, setLoading]   = useState(true);
    const [redirectId, setRedirectID]  = useState("");
    const [data, setData] = useState({});
    const user_id = props.match.params.id;
    
    const SuperAdmin = (value) => {
        props.SuperAdmin(user_id, value);
    };
    const FormChange = (e) => {
        let update = data;
        update[e.target.name] = e.target.value;
        setData( update );
    }

    useEffect(() => {
        const unsubscribe = async () => {
            await props.ClearUsers();
            return props.GetUserDetails(user_id);
        };
        unsubscribe();
        let unsub = unsubscribe;
        return async () => {
            await unsub();
        };
    },[]);

    // useEffect(() => {
    //     console.log(props.users);
    // },[props.users]);

    // useEffect(() => {
    //     if( typeof userData.max_id === "undefined" && 
    //         typeof props.user.max_id !== "undefined" && 
    //         isLoading === true ) {
    //         setUserData( props.user );
    //         setLoading(false);
    //     } else if( userData != props.user ) {
    //         setUserData( props.user );
    //     }
    // },[props]);

    // if( userData.exists === false ) {
    //     return <Redirect push to={`/admin/`} />;
    // }

    if( isLoading && _.isEmpty(props.user) ) 
        return (
            <div className="container gateDetail">
                <div className="row" style={{ marginBottom: "0"}}>
                    <div className="col s6" style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                        <Spin size="large" />
                    </div>
                </div>
            </div>
        );

    if (redirectId !== "") {
        return <Redirect push to={`/admin/gate/${redirectId}`} />;
    }

    const { name, gates, phone } = props.user;

    const columns = [
        {
            title: 'Gate Site',
            dataIndex: 'name',
            width: '25%',
        },
        {
            title: 'Address',
            dataIndex: 'address',
            width: '30%',
        },
        {
            title: 'Max ID',
            dataIndex: 'max_id',
        },
    ];
    
    return (
        <div className="container gateDetail">
            <div className="row" style={{ marginBottom: "0"}}>
                <div className="col s6">
                    <Col span={24}>
                        <Layout className="site-layout-background" style={{ padding: '24px 0', backgroundColor: "#fff" }}>
                            <Content style={{ padding: '0 24px', minHeight: 280 }}>
                                <div className="col s12" style={{padding: "15px", marginTop: "15px"}}>
                                    <TextField variant="outlined" fullWidth onChange={(e) => FormChange(e)} name="name" defaultValue={name} label="User Name" disabled/>
                                </div>
                                <div className="col s12" style={{padding: "15px"}}>
                                    <TextField variant="outlined" fullWidth onChange={(e) => FormChange(e)} name="phone" defaultValue={phone} label="Phone" disabled />
                                </div>
                                <div className="col s12" style={{margin: "15px", display: "flex", padding: "15px", justifyContent: "space-between", maxWidth: "200px", border: "1px dashed #ccc"}}>
                                    <span>Is Super Admin?</span>
                                    <Switch defaultChecked={props.user.isAdmin} onChange={v => SuperAdmin(v)} />
                                </div>
                                {gates && <Table
                                    // title={() => 
                                    //     <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                    //         <h2>User Gate Access</h2>
                                    //     </div>
                                    // }
                                    columns={columns}
                                    rowKey={gate => gate.id}
                                    dataSource={gates}
                                    pagination={{ pageSize: 12 }}
                                    onRow={(record, rowIndex) => {
                                        return {
                                            onClick: e => setRedirectID(record.id), // click row
                                        };
                                    }}
                                />}
                            </Content>
                        </Layout>
                    </Col> 
                </div>
            </div>
        </div>
    );
    
}

const mapStateToProps = (state) => {
    return {
        user:   state.user.user
    }
}

function formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3]
    }
    return null
}

const mapDispatchToProps = (dispatch) => {
    return {
        ClearUsers:        () => dispatch(ClearUsers()),
        GetUserDetails:   (user_id) => dispatch(GetUserDetails(user_id)),
        SuperAdmin:       (user_id,value) => dispatch(SuperAdmin(user_id,value)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserDetails);
